import React, { ReactElement } from 'react';
import './notificationItem.less';
import { modules } from '../../../utils/redirectNotification';
import moment from 'moment';
import { updateSelectedDetail } from '../../../store/actions/inPatientAction';
import { base64UrlEncode, centeredNotification } from '../../../utils/utility';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Button } from 'antd';
import { readNotifications, updateIsOnNotificationflow, updateIsReadNotification } from '../../../store/actions/utilAction';
import { customGTMEvent } from '../../../modules/crm/inPatient/service/crmUtils';
interface INotificationProps {
  data: any;
  key: number;
  highlight: string;
  onClose: () => void;
  setUnreadNotificationsList: any;
}

const HighlightedText = ({
  text,
  highlight,
}: {
  text: string;
  highlight: string;
}): ReactElement => {
  const parts = text?.split(new RegExp(`(${highlight})`, 'gi'));
  return (
    <span>
      {parts?.map(
        (part: string, i: number): ReactElement => (
          <span
            key={i}
            style={
              part?.toLowerCase() === highlight?.toLowerCase()
                ? { background: 'yellow' }
                : {}
            }
          >
            {part}
          </span>
        ),
      )}
    </span>
  );
};

const NotificationItem = ({
  data, key, highlight, onClose, setUnreadNotificationsList,
}: INotificationProps): ReactElement => {
  const {
    isRead,
    title,
    content,
    imagePath,
    tags,
    messageCreatedOn: timestamp,
    notificationMessageId,
  } = data;

  const timeDuration = moment
    .duration(moment(timestamp).diff(moment(new Date())))
    .humanize(true);
  const dispatch = useDispatch();
  const history = useHistory();

  const handleMarkAsRead = (messageId: number, isRowClick: boolean = false): void => {
    if (isRowClick) {
      dispatch(readNotifications([messageId], (): void => { }, onFailureRead, false));
    } else {
      setUnreadNotificationsList((prevState: any): any => [...prevState, messageId]);
      dispatch(updateIsReadNotification(messageId));
    }
  };

  const onFailureRead = (errorMessage: string): void => {
    centeredNotification(errorMessage);
  };

  const rowClick = (record: any): void => {
    if (!record.isRead) {
      handleMarkAsRead(notificationMessageId, true);
    }
    const claimParams = {
      PayerClaimNo: record?.payerClaimNo || '',
      HospActionId: record?.hospActionId || '',
      PayerId: record?.payerId || '',
      ProductCode: record?.productCode || '',
      ProviderId: record?.providerId || '',
    };
    if (claimParams !== null) {
      const {
        PayerClaimNo, HospActionId, PayerId,
        ProductCode, ProviderId,
      } = claimParams;
      const isCancel = false;
      const uniquePayerId = `${PayerId}${ProductCode || ''}`;
      try {
        if (HospActionId || PayerClaimNo) {
          if (claimParams?.HospActionId) {
            dispatch(updateSelectedDetail(claimParams));
            history.push(`/claims/in-patient/detail/${base64UrlEncode(`${base64UrlEncode(PayerClaimNo)}/${HospActionId}/${PayerId}/${uniquePayerId}/${ProductCode}/${isCancel}/${ProviderId}`)}`);
          } else {
            dispatch(updateSelectedDetail(claimParams));
            history.push(`/claims/in-patient/detail/${base64UrlEncode(`${base64UrlEncode(PayerClaimNo)}/${0}/${PayerId}/${uniquePayerId}/${ProductCode}/${isCancel}/${ProviderId}`)}`);
          }
        } else {
          history.push('/claims/in-patient');
        }
        onClose();
        customGTMEvent({
          event: 'Click on a Notification',
          claimNumber: PayerClaimNo,
          timestamp,
          claimStatus: '',
          title,
        });
        dispatch(updateIsOnNotificationflow(true));
      } catch (e) {
        history.push('/claims/in-patient');
        onClose();
      }
    }
  };

  return (
    <div className={`notification-item ${isRead ? 'read' : ''}`}>
      {imagePath ? (
        <img className={'notification-image'} src={imagePath} alt={''} />
      ) : null}
      <div className={'notification-content'} key={key}>
        <div className={'notification-tags-and-timestamp'}>
          <div className="notification-tags">
            {tags?.map((tag: string, i: number): ReactElement => {
              return (
                <span
                  key={i}
                  className={`notification-tag ${modules?.includes(tag) ? 'highlighted' : ''
                    }`}
                >
                  {<HighlightedText text={tag} highlight={highlight} />}
                </span>
              );
            })}
          </div>
          <div className={'notification-timestamp'}>{timeDuration}</div>
        </div>
        <div className="notification-title-description" onClick={(): any => { rowClick(data); }}>
          <div className="notification-title">
            <HighlightedText text={title} highlight={highlight} />
          </div>
          <div className="notification-description" dangerouslySetInnerHTML={{__html: content}} />
        </div>
        <div>
          {!isRead &&
            <span className={'mark-a-read'}>
              <Button
                type="link"
                onClick={(event: any): void => handleMarkAsRead(notificationMessageId)}
              >
                Mark as read
              </Button>
            </span>
          }
        </div>
      </div>
    </div>
  );
};

export default NotificationItem;
